import React from 'react';
import CaProfileAwardsView from "./CaProfileAwardsView";
import { withTranslation } from "react-i18next";


class CaProfileAwardsContainer extends React.Component {

    constructor(props) {
        super(props);
        this.handleItemClick = this.handleItemClick.bind(this);
    }
    handleItemClick(item) {
        if (!!item.redemptionCode) {
            window.alert(this.props.t('account_page.awards.alert_text') + item.redemptionCode);
            return;
        }
        if (!!item.redemptionLink) {
            window.open(item.redemptionLink);
            return
        }
    }
    render() {
        const { tier } = this.props;

        return (
            tier !== undefined ? <CaProfileAwardsView tier={tier} header={this.props.t('account_page.awards.header')} handleItemClick={this.handleItemClick} /> : null
        )
    }
}

export default withTranslation("translations")(CaProfileAwardsContainer);




